import { Component } from 'react'

class Html5Device extends Component {
  render() {
    const { fileSrc } = this.props

    return (
      <div className="phone-container col-xs-5">
        {fileSrc && (
          <embed key={Math.uuid()} src={fileSrc} height={600} width={300} />
        )}
      </div>
    )
  }
}

export default Html5Device
